import image from "../assets/images/feedback.png";
import image1 from "../assets/images/feedback1.png";
import image2 from "../assets/images/feedback2.png";
import image3 from "../assets/images/feedback3.png";
import image4 from "../assets/images/feedback4.png";
import image5 from "../assets/images/feedback5.png";

export const feedbacks = [
  {
    id: 1,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image,
  },
  {
    id: 2,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image: image1,
  },
  {
    id: 3,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image: image2,
  },
  {
    id: 4,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image: image3,
  },
  {
    id: 5,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image: image4,
  },
  {
    id: 6,
    name: "Amos Johnson",
    email: "amosjohnson@gmail.com",
    feedback:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et viverra erat mauris, etiam. Aliquam neque vulputate fermentum feugiat nec risus scelerisque nulla dolor. Elit id turpis eget sapien, sed praesent leo.",
    date: "Mon. 18th October, 2021  18:00:23",
    image: image5,
  },
];
